import React from "react";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import { deviceSize } from  "../../components/responsive";


import Food from "../../images/FoodPhoto.png"



//MiddleSectionContainer
const MsC  =styled.div`

 width:100%;
 background: white;
 display: grid;
 grid-template-columns: 1fr;
 gap: 30px;


 @media screen and (max-width: 768px){
	display: flow;
 }

`;

const Column1 =styled.div`
	margin-bottom:15px;
	grid-area: 1 / 1 / 2 / 2;
	width: 90%;


 @media screen and (max-width:${deviceSize.tablet}px){

 	  width:100%;
 	}

	@media screen and (max-width: ${deviceSize.mobile}px) {
		width: 100%;
		
	}
`;

const Column2 =styled.div`
	margin-bottom:1px;
	padding:0 103px 0 0;
	grid-area: 1 / 2 / 2 / 3;
	display: flex;
  	flex-direction: column;
  	justify-content: center;	

	@media screen and (max-width: ${deviceSize.tablet}px) {
		padding:0 0px 0 0;
	}



	@media screen and (max-width: ${deviceSize.mobile}px) {
		padding:0 0 0 0;
		width: 100%;

	}
`;

//textwrappper
const Tw =styled.div`

	padding-top: 5%;
	padding-bottom:60px;
	margin-left:65px;


	@media screen and (max-width:${deviceSize.tablet}px){
		margin-left:0px;
		width:100%;

	}



	@media screen and (max-width:${deviceSize.mobile}px){
		width:100%;
		padding: 10%;
	}
`;



const Subtitle = styled.p`

	font-family: 'Sunflower';
	font-style: normal;
	font-weight: 300;
	font-size: 20px;
	line-height: 30px;
	color: #282828;
	text-align:left;

@media screen and (max-width: ${deviceSize.mobile}px) {
	font-size:13px;
	width:100%;
}

`;


const  ImgWrap = styled.div`


 @media screen and (max-width:${deviceSize.tablet}px){
 		margin-left:7%;

 	}

 @media screen and (max-width:${deviceSize.mobile}px){
 		margin-left:0px;
 	  width:100%;

 	}

`;

const ImgC=styled.img`

 width: 315px;
 height: 411px;
 padding-right:0;


@media screen and (max-width:${deviceSize.tablet}px){
	transform: rotate(90deg);

 	}


 	 	@media screen and (max-width:${deviceSize.mobile}px){
 		 height:205px;
 		 width:157.5px;
 		 transform: rotate(90deg);

 	}

`;



export function BottomSectionContactUs(){
		const isTablet= useMediaQuery({maxWidth:deviceSize.tablet});

	return(
	<MsC> 
		    		  	<Column1 id="column1">
		    						<Tw>
		    		  		 	<Subtitle>
								   At the onset of the COVID-19 outbreak, the city of New York requested emergency response expansion to handle an increase of roughly 200,000 calls related to the pandemic. In a challenging and chaotic time in which New York needed a lifeline, Exp Staffing sprang into action.
		    		  		 	</Subtitle>

		    		  		 	<Subtitle>
								   Within three days, our emergency response team staffed 120 call agents ready to steward NYC and the five boroughs through the pandemic.
		    		  		 	</Subtitle>

		    		  		 	<Subtitle>
								   The ensuing result? Ten thousand+ calls per day, and over 325 million meals on our neighbor’s tables. Not only did Exp provide meals, we provided vital information related to the virus and how New Yorkers could protect themselves and their loves ones
		    		  		 	</Subtitle>

		    		  		 		{isTablet &&(
		    		  		 		<ImgWrap>
		    		  					 <ImgC src={Food} alt="picture of food in contianer"/> 
		    		  				</ImgWrap>
		    		  				)}

		    		  		 	{! isTablet && (
		    		  		 	<Subtitle>
									In other words, when others sheltered from the crisis, Exp ran toward it.
		    		  		 	</Subtitle>
		    		  		 		 	)}

		    		  		 		{! isTablet && (
		    		  		 	<Subtitle>
									Since that time, Exp Staffing’s role in the GetFoodNYC program has evolved into NYC311— assisting the public navigate the five boroughs by providing economic, health, social services, and logistical information via our call centers.
		    		  		 	</Subtitle>
		    		  		 	)}
								<Subtitle>
									Exp has proven itself to be organized, expeditious, thorough and accommodating to our clients. The results continue to speak for themselves, and we’d be ecstatic to work with you to reach your staffing goals.
								</Subtitle>
								<Subtitle>
								To hear directly from our CEO about Exp and the GetFood program, check out the video below.
								</Subtitle>
		    		  		 	</Tw>
		    		    </Column1>
		    		  	<Column2>
		    		  				{! isTablet && (
		    		  				<ImgWrap>
		    		  					 <ImgC src={Food} alt="picture of food in contianer"/>
		    		  				</ImgWrap>
		    		  				)}	
		    		  	</Column2>	
		</MsC>
		);
}